import {
  Icon,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";

import { useSidebarNav } from "../use-sidebar-nav";

/** Map's primary destinations. One entry today — the workspace-wide map. */
export function MapNavSection() {
  const { navigate, isActive } = useSidebarNav();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isActive("/map", true)}
            onClick={() => navigate("/map")}
          >
            <Icon name="radar" />
            <Text truncate>Live Map</Text>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
